var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcByReceiver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib1ygyrjub",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9lqewqv8ze",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lnbv3vslrg",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e1s7o8jkda",
    d: "M15.997 4.18L16 9.605v.238C16 12.455 14.37 14 11.614 14H4.387C1.629 14 0 12.455 0 9.842v-5.69C0 1.539 1.63 0 4.387 0h7.224c2.757 0 4.386 1.539 4.386 4.152v.029z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icw5ja6ujd",
    d: "M3.839 6.148c2.081 0 3.838.329 3.838 1.599S5.91 9.333 3.84 9.333C1.757 9.333 0 9.005 0 7.735s1.768-1.587 3.839-1.587zm0-6.148c1.41 0 2.54 1.099 2.54 2.47 0 1.37-1.13 2.47-2.54 2.47-1.41 0-2.54-1.1-2.54-2.47 0-1.371 1.13-2.47 2.54-2.47z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -571) translate(0 356) translate(92) translate(16 206) translate(12 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g65x2xbrec",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1s7o8jkda"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#ib1ygyrjub)",
    xlinkHref: "#e1s7o8jkda"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#ib1ygyrjub)",
    mask: "url(#g65x2xbrec)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V14H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -571) translate(0 356) translate(92) translate(16 206) translate(12 9) translate(4 2.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fo41iewa0f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icw5ja6ujd"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#9lqewqv8ze)",
    fillRule: "nonzero",
    xlinkHref: "#icw5ja6ujd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#lnbv3vslrg)",
    mask: "url(#fo41iewa0f)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H8V9.333H0z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcByReceiver);
export default __webpack_public_path__ + "static/media/customer-ic-by-receiver.c3bc7ceb3b4acab1d03067d372196162.svg";
export { ForwardRef as ReactComponent };